import React from "react";

export default function BrandLockup() {
  return (
    <span className="grupa-lockup">
      <span>GrupaAI</span>
    </span>
  );
}
